import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import LoyaltyLandingPageTierInformation from 'loyalty/components/LoyaltyLandingPageTierInformation'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Section = styled(Pane)`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} 0;
  }
`

function LoyaltyLandingPageDiscoverTiersSection() {
  return <Section paletteType="inverse">
    <LayoutContainer variant="medium">
      <Group direction="vertical" gap={72}>
        <VerticalSpacer gap={32}>
          <VerticalSpacer gap={8}>
            <Heading variant="heading2" align="center">
              Discover a world of rewards, one tier at a time
            </Heading>
            <BodyText variant="large" align="center">
              Unlock bigger and better travel benefits as you move from Bronze to Platinum.
            </BodyText>
          </VerticalSpacer>
          <LoyaltyLandingPageTierInformation />
        </VerticalSpacer>
      </Group>
    </LayoutContainer>
  </Section>
}

export default LoyaltyLandingPageDiscoverTiersSection
